// extracted by mini-css-extract-plugin
export default {"b2":"GoogleLoginContainer_b2__fwnf2","dmb2":"GoogleLoginContainer_dmb2__+HNnD","signInButton":"GoogleLoginContainer_signInButton__rG2rQ"};